<template>
  <nav class="nav-bar" role="navigation">
    <ul class="row m-0 p-0">
      <li class="col" v-for="(item, i) in items" :key="i" :class="{'current': isCurrent(item)}">
        <a :href="item.url" :title="item.label">
          <span class="icon" :class="`icon-${item.icon}`"></span>
          <span class="label">{{ item.label }}</span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    current: { type: String },
    showLearningPaths: { type: Boolean, default: false },
    showVideos: { type: Boolean, default: false },
    showTechDocs: { type: Boolean, default: false },
  },
  computed: {
    items() {
      var items = [];
      items.push({
        label: `Home`,
        icon: `home`,
        url: "/",
      });
      if (this.showLearningPaths) {
        items.push({
          label: `Learning Paths`,
          icon: `grad-cap`,
          url: this.route("learning-paths.index"),
        });
      }
      items.push({
        label: `Courses`,
        icon: `courses`,
        url: this.route("catalog.online"),
      });
      if (this.$root.isLoggedIn && !this.$root.isPublicUser) {
        items.push({
          label: `Events`,
          icon: `events`,
          url: this.route("event-calendar.index"),
        });
      }
      if (this.$root.isLoggedIn) {
        items.push({
          label: `Training`,
          icon: `training`,
          url: this.route("training.history.index", { type: "online" }),
        });
      }
      if (this.$root.isLoggedIn && this.showVideos) {
        items.push({
          label: `Videos`,
          icon: `video-circle`,
          url: this.route("videos.index"),
        });
      }
      if (this.showTechDocs) {
        items.push({
          label: `Tech Docs`,
          icon: `book`,
          url: this.route("training.documents.index"),
        });
      }
      if (this.$root.isAdmin) {
        items.push({
          label: `Admin`,
          icon: `admin`,
          url: this.route("admin.courses.index"),
        });
      }
      return items;
    },
  },
  methods: {
    isCurrent(item) {
      return this.current == item.label;
    },
  },
};
</script>
